/* eslint-disable @nx/enforce-module-boundaries */
import React, { useContext, useMemo } from 'react';
import { Stack, Card, Heading, VStack, Button, Box, Badge } from '@mybridge/ui';
import {
  EyeViewIcon,
  FollowNewIcon,
  InvitationIcon,
  SuggestionListIcon,
  TeamIcon,
  ProfileViewIcon,
  TeamBlockedIcon,
  BlockRoundIcon,
} from '@mybridge/icons';
import { CompanyIcon } from '@mybridge/icons/Company';
import { useRouter } from 'next/router';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { MyNetworkContext } from '../context';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { getProfileViewsCount } from 'v4/store/actions/user-profile.actions';

const NetworkPageSidebar = ({ isActive, props }) => {
  const { t } = useTranslator();
  const dispatch = useDispatch();
  const { pendingInvites } = useSelector((state) => state.connection); 
  // const {
  //   profileViewers,
  // } = useContext(MyNetworkContext); 

  // const newViewers = useMemo(() => {
  //   return profileViewers?.filter?.((pv) => {
  //     // console.log(moment(pv.created));
  //     return moment(pv.created)?.isAfter(moment().subtract(90, 'days'));
  //   });
  // }, [profileViewers]);

  // Fetch new profile views count from the new API
  const { data: profileViewsData } = useQuery({
    queryKey: ['profile-views-count'],
    queryFn: async () => {
      const resp = await dispatch(getProfileViewsCount());
      return resp?.payload;
    },
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000,
    enabled: true,
  });
  
  const newProfileViewsCount = profileViewsData?.new_profile_views_count ?? 0;

  const router=useRouter();
  const menuList = [
    {
      name: t('profileNetwork.connection') || 'Connection',
      icon: <TeamIcon color="#575757" />,
      link: 'my-circle',
      showOnMobile: true,
      defaultActive:false
    },
    {
      name: t('profileNetwork.invitations') || 'Invitations',
      icon: <InvitationIcon color="#575757" />,
      link: '',
      showOnMobile: true,
      defaultActive:true
    },
    {
      name: t('profileNetwork.followingFollowers') || 'Following & followers',
      icon: <FollowNewIcon color="#575757" />,
      link: 'follow',
      showOnMobile: true,
      defaultActive:false
    },
    {
      name: t('profileNetwork.pages') || 'Pages',
      icon: <CompanyIcon color="#575757" />,
      link: 'pages',
      showOnMobile: true,
      defaultActive:false
    },
    {
      name: t('profileNetwork.profileViews') || 'Profile views',
      icon: <ProfileViewIcon color="#575757" />,
      link: 'viewers',
      showOnMobile: true,
      defaultActive:false
    },
    {
      name: t('profileNetwork.blockedNetworks') || 'Blocked networks',
      icon: <BlockRoundIcon color="#575757" />,
      link: 'blocked',
      showOnMobile: true,
      defaultActive:false
    },
  ];

  return (
    <Stack w={['100%', '100%', '100%', '300px']} minH="100vh" bg="white"  me={2}>
      <Box p={[4,0,0, 4]} pt={[4,4,4, 4]} >
        <Heading fontSize="18px" fontWeight="600" color="#3B718D" pb={3}>
          {t('profileNetwork.myNetwork') || "myNetwork"}
        </Heading>
        <VStack align="stretch">
          {menuList?.map((menu, i) => (
            <Button
              position='relative'
              variant="ghost"
              onClick={() => router.push(`/profile/network/${menu.link}`)}
              key={i}
              // leftIcon={menu.icon}
              justifyContent="flex-start"
              fontWeight="400"
              borderRadius="50px"
              h="50px"
              isActive={isActive === menu.link || (isActive === 'manage' && menu.name === t('profileNetwork.invitations')) ? true : false}
              color="#575757"
              sx={{
                ':hover': {
                  backgroundColor: 'brandGray.500',
                  cursor: 'pointer',
                  color: 'brandPrimary.500',
                  fontWeight: '600',
                  path: {
                    fill: 'brandPrimary.500',
                  },
                },
                '&[data-active]': {
                  backgroundColor: 'brandGray.500',
                  cursor: 'pointer',
                  color: 'brandPrimary.500',
                  fontWeight: '600',
                  path: {
                    fill: 'brandPrimary.500',
                  },
                },
              }}
              >
              {menu.name}
              {menu.link === '' && pendingInvites?.length > 0 ? (
                <Badge
                  // fontSize="8px"
                  position="absolute"
                  bg="brandRed.500"
                  color="white"
                  borderRadius="100%"
                  minW="25px"
                  border= '2px solid #ffffff'
                  p="3px 5px"
                  lineHeight="normal"
                  right="8px"
                  top="12px"
                >
                  {(pendingInvites?.length)}
                </Badge>
              ) 
              : menu.link === 'viewers' && newProfileViewsCount > 0 ? (
                <Badge
                  position="absolute"
                  bg="brandRed.500"
                  color="white"
                  borderRadius="100%"
                  minW="25px"
                  border= '2px solid #ffffff'
                  p="3px 5px"
                  lineHeight="normal"
                  right="8px"
                  top="12px"
                >
                  {newProfileViewsCount}
                </Badge>
              )
              :('')}
            </Button>
          ))}
        </VStack>
      </Box>
    </Stack>
  );
};

export default NetworkPageSidebar;
